import { CommonModule } from '@angular/common';
import {
	ChangeDetectionStrategy, ChangeDetectorRef,
	Compiler, Component, ComponentFactory, ComponentRef, ModuleWithComponentFactories, NgModule, OnInit, ViewChild,
	ViewContainerRef
} from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { PaginationModule } from 'ngx-bootstrap/pagination';
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import { SafeHtmlPipe } from 'src/app/pipe/safe.pipe';
import { LazyLoadScriptService } from '../../lazy_load_script_service';
import { PageService } from '../../services';
import { Meta, Title } from '@angular/platform-browser';
pdfMake.vfs = pdfFonts.pdfMake.vfs;

declare function OneHr();

@Component({
	selector: 'survey-schedule',
	templateUrl: './survey_schedule.component.html',
	styleUrls: ['./survey_schedule.component.scss']
})
export class survey_scheduleComponent implements OnInit {

	@ViewChild('container', { static: true, read: ViewContainerRef }) container: ViewContainerRef;

	private componentRef: ComponentRef<{}>;
	constructor(
		private service: PageService,
		public sanitizer: DomSanitizer,
		private compiler: Compiler,
		public cdRef: ChangeDetectorRef,
		private meta: Meta,
		private title: Title,
		private lazyLoadService: LazyLoadScriptService
	) {
		this.meta.addTags([
			{ name: 'description', content: 'Survey Schedule page of UN - One HR - Salary Survey' },
			{ name: 'author', content: 'One HR, Salary Survey' },
			{ name: 'keyword', content: 'One HR, Salary Survey, Survey Schedule' }
		]);
		this.setTitle('UN - Survey Schedule');
	}
	public setTitle(newTitle: string) {
		this.title.setTitle(newTitle);
	}
	slug = 'survey_schedule';
	surveyscheduleList;
	totalItems = 10;
	currentPage = 1;
	itemPerPage = 10;
	pageVars: any = { sortByTitle: 'Type Ascending', itemPerPage: 10 };
	template: string;
	tempCode: string;

	public ngOnInit() {
		this.service.get(this.slug).subscribe((response: any) => {
			var str = response.data.html?.map(ele => ele.html).join("");
			this.template = str;
			this.tempCode = `
			<div class="section" *ngIf="totalItems > 0">
			<div class="container-fluid">
				<div class="col-md-12 p-5 mt-2 grey-border-bottom" style="padding: 5px !important;">
					<div class="d-flex flex-row-reverse">
						<div class="p-2" *ngIf="surveyschedule.length > 0">
							<div ngbDropdown class="d-inline-block">
								<label class="custom-lbl-bg">
									Records per page
									<button class="btn tiny-select dropdown-toggle" style="font-size: 11px;padding: 8px 20px;"
										ngbDropdownToggle>
										{{pageVars.itemPerPage}}
									</button>
								</label>
								<div ngbDropdownMenu class="rounded-0" aria-labelledby="Records Per Page">
									<button ngbDropdownItem class="pt-1 pagVar_Sschedule" aria-label="Sort Jobs" id="5"
										(click)="pageVars.itemPerPage=5;fetchSurveySchedules()">5</button>
									<button ngbDropdownItem class="pt-1 pagVar_Sschedule" aria-label="Sort Jobs" id="10"
										(click)="pageVars.itemPerPage=10;fetchSurveySchedules()">10</button>
									<button ngbDropdownItem class="pt-1 pagVar_Sschedule" aria-label="Sort Jobs" id="20"
										(click)="pageVars.itemPerPage=20;fetchSurveySchedules()">20</button>
									<button ngbDropdownItem class="pt-1 pagVar_Sschedule" aria-label="Sort Jobs" id="50"
										(click)="pageVars.itemPerPage=50;fetchSurveySchedules()">50</button>
								</div>
							</div>
						</div>
						<div class="p-2" *ngIf="surveyschedule.length > 0">
							<button class="ss-btn" (click)="exportSurveySchedule()">Export As PDF</button>
						</div>
					</div>
				</div>
				<!-- need to add here -->
			</div>
			<div class="container-fluid pt-0 d-none d-sm-block">
				<div class="col-12 p-0 m-0">
					<table class="table table-survey">
						<thead>
							<tr>
								<th scope="col" class="col-1 u-text-primary clickable"
									(click)="sortSurveySchedules('dutystation_info.name');pageVars.sortByTitle=pageVars.sort['dutystation_info.name']==1?'Duty Station Ascending':'Duty Station Descending'">
									Duty Station <i class="fas fa-sort"></i>
								</th>
								<th scope="col" class="col-1 u-text-primary clickable"
									(click)="sortSurveySchedules('country_info.name');pageVars.sortByTitle=pageVars.sort['country_info.name']==1?'Country Ascending':'Country Descending'">
									Country <i class="fas fa-sort"></i>
								</th>
								<th scope="col" class="col-1 u-text-primary clickable"
									(click)="sortSurveySchedules('surveyDutyStationCategoryId_info?.name');pageVars.sortByTitle=pageVars.sort['surveyDutyStationCategoryId_info?.name']==1?'Category Ascending':'Category Descending'">
									Category <i class="fas fa-sort"></i>
								</th>
								<th scope="col" class="col-2 u-text-primary clickable"
									(click)="sortSurveySchedules('lastSurveyScheduleYear');pageVars.sortByTitle=pageVars.sort['lastSurveyScheduleYear']==1?'Last Completed survey Ascending':'Last Completed survey Descending'">
									Year of last completed Survey <i class="fas fa-sort"></i>
								</th>
								<th scope="col" class="col-2 u-text-primary clickable"
									(click)="sortSurveySchedules('currentOrNextSurveyScheduleYear');pageVars.sortByTitle=pageVars.sort['currentOrNextSurveyScheduleYear']==1?'Current/Next survey Ascending':'Current/Next Survey Descending'">
									Year of Current/Next Survey <i class="fas fa-sort"></i>
								</th>
								<th scope="col" class="col-2 u-text-primary clickable"
									(click)="sortSurveySchedules('currentOrNextSurveyScheduleStatusId_info.name');pageVars.sortByTitle=pageVars.sort['currentOrNextSurveyScheduleStatusId_info.name']==1?'Status of Current/Next Survey Ascending':'Status of Current/Next Survey Descending'">
									Status of Current/Next Survey <i class="fas fa-sort"></i>
								</th>
								<th scope="col" class="col-2 u-text-primary clickable"
									(click)="sortSurveySchedules('methodofAnnualInterimAdjustmentId_info.name');pageVars.sortByTitle=pageVars.sort['methodofAnnualInterimAdjustmentId_info.name']==1?'Method of Annual Interim Adjustment Ascending':'Method of Annual Interim Adjustment Descending'">
									Method of Annual Interim Adjustment <i class="fas fa-sort"></i>
								</th>
								<th scope="col" class="col-2 u-text-primary clickable"
									(click)="sortSurveySchedules('lastCompletedInterimAdjustment');pageVars.sortByTitle=pageVars.sort['lastCompletedInterimAdjustment']==1?'Last Completed Interim Adjustment Ascending':'Last Completed Interim Adjustment Descending'">
									Last Completed Interim Adjustment <i class="fas fa-sort"></i>
								</th>
							</tr>
						</thead>
						<tbody *ngIf="surveyschedule.length > 0">
							<tr *ngFor="let ss1 of surveyschedule">
								<td class="col-1">{{ ss1.dutystation_info.name }}</td>
								<td class="col-1">{{ ss1.country_info.name }}</td>
								<td class="col-1">{{ ss1.surveyDutyStationCategoryId_info?.name }}</td>
								<td class="col-2">{{ ss1.lastSurveyScheduleYear }}</td>
								<td class="col-2">{{ ss1.currentOrNextSurveyScheduleYear }}</td>
								<td class="col-2">
									{{ ss1.currentOrNextSurveyScheduleStatusId_info.name }}
									{{ ss1.currentOrNextSurveyScheduleStatusYear }}
								</td>
								<td class="col-2">{{ ss1.methodofAnnualInterimAdjustmentId_info.name }}</td>
								<td class="col-2">{{ ss1.lastCompletedInterimAdjustment }}</td>
							</tr>
						</tbody>
						<tbody *ngIf="surveyschedule.length == 0">
							<tr class="row">
								<td class="col-12 text-center">No records found</td>
							</tr>
						</tbody>
					</table>
					<pagination *ngIf="surveyschedule.length > 0" [totalItems]="totalItems" [itemsPerPage]="pageVars.itemPerPage"
						[boundaryLinks]="true" previousText="&lsaquo;" nextText="&rsaquo;" firstText="&laquo;" lastText="&raquo;"
						[maxSize]="6" [(ngModel)]="currentPage" name="currentPage" class="justify-content-center"
						(pageChanged)="pageChanged($event)" (pageBoundsCorrection)="pageChanged($event)">
					</pagination>
				</div>
			</div>
		
			<div class="container-fluid d-sm-none">
				<div class="card shadow border-0 my-3" style="box-shadow: -0px 1px 3px 0px #aaaaaa;border-radius: 0;"
					*ngFor="let ss of surveyschedule">
					<div class="card-header d-flex border-0 p-2" style="border-radius: 0;">
						<b>Duty Station: </b>
						<span>{{ss.dutystation_info.name}}</span>
					</div>
					<div class="d-flex p-0" style="font-size: 0.9em;">
						<b>Country:</b>
						<span> &nbsp; {{ss.country_info.name}}</span>
					</div>
					<div class="card-header d-flex border-0 p-2" style="border-radius: 0;">
						<b>Category: </b>
						<span>{{ss.surveyDutyStationCategoryId_info?.name}}</span>
					</div>
					<div class="card-body p-2">
						<div class="d-flex p-0" style="font-size: 0.9em;">
							<b>Year of Last Completed Survey:</b>
							<span> &nbsp; {{ss.lastSurveyScheduleYear}}</span>
						</div>
						<div class="d-flex p-0" style="font-size: 0.9em;">
							<b>Year of Current/Next Survey:</b>
							<span> &nbsp; {{ss.currentOrNextSurveyScheduleYear}}</span>
						</div>
						<div class="d-flex p-0" style="font-size: 0.9em;">
							<b>Status of Current/Next Survey:</b>
						</div>
						<div class="d-flex p-0" style="font-size: 0.9em;">
							<span> &nbsp;
								{{ ss.currentOrNextSurveyScheduleStatusId_info.name }}
								{{ ss.currentOrNextSurveyScheduleStatusYear }}
							</span>
						</div>
						<div class="d-flex p-0" style="font-size: 0.9em;">
							<b>Method of Annual Interim Adjustment:</b>
						</div>
						<div class="d-flex p-0" style="font-size: 0.9em;">
							<span> &nbsp; {{ss.methodofAnnualInterimAdjustmentId_info.name}}</span>
						</div>
						<div class="d-flex p-0" style="font-size: 0.9em;">
							<b>Last Completed Interim Adjustment:</b>
							<span> &nbsp; {{ss.lastCompletedInterimAdjustment}}</span>
						</div>
					</div>
				</div>
				<pagination *ngIf="surveyschedule.length > 0" [totalItems]="totalItems" [itemsPerPage]="pageVars.itemPerPage"
					[boundaryLinks]="true" previousText="&lsaquo;" nextText="&rsaquo;" firstText="&laquo;" lastText="&raquo;"
					[maxSize]="6" [(ngModel)]="currentPage" name="currentPage" class="justify-content-center"
					(pageChanged)="pageChanged($event)" (pageBoundsCorrection)="pageChanged($event)">
				</pagination>
			</div>
		</div>
         `;
			// // <th scope="col" class="col-2 u-text-primary clickable" (click)="sortSurveySchedules('dutystation_info.name');pageVars.sortByTitle='Duty Station Ascending'" >Duty Station <i class="fas fa-sort"></i></th>
			// <ng-template #elseBlock>
			// <div class="section">
			// <div class="container-fluid">
			// Sorry, no survey schedule were found
			// </div>
			// </div>
			// </ng-template>
			this.compileTemplate();
		});
		this.fetchSurveySchedule();
	}

	compileTemplate() {
		let metadata = {
			selector: `runtime-component-sample`,
			template: this.template + this.tempCode,
			changeDetection: ChangeDetectionStrategy.Default
		};

		let factory = this.createComponentFactorySync(this.compiler, metadata, null, this);

		if (this.componentRef) {
			this.componentRef.destroy();
			this.componentRef = null;
		}
		this.componentRef = this.container.createComponent(factory);
		this.lazyLoadService.loadScript('/assets/js/onehr.js').subscribe(_ => {

		});
	}

	private createComponentFactorySync(compiler: Compiler, metadata: Component, componentClass: any, THIS: any,): ComponentFactory<any> {
		const cmpClass = componentClass || class RuntimeComponent {
			surveyschedule: any = [];
			totalItems = 10;
			currentPage = 1;
			itemPerPage = 10;
			pageVars: any = { sortByTitle: 'Duty Station Ascending', itemPerPage: 10, sort: {} };
			allSurveySchedules: any = [];
			exportPDFTable;

			public ngOnInit() {
				this.fetchSurveySchedules();
			}

			fetchSurveySchedules() {
				THIS.service.loadSurveyScheduleList(this.currentPage - 1, this.pageVars.itemPerPage, this.pageVars.sortBy, this.pageVars.sortDirection).subscribe(res => {
					this.surveyschedule = res.data.result;
					this.totalItems = res.data.total;
				});
			}

			sortSurveySchedules(attr, descending?) {
				this.pageVars.sortBy = attr;
				if (!descending) {
					if (this.pageVars.sort[attr]) {
						this.pageVars.sort[attr] = -this.pageVars.sort[attr];
					} else {
						this.pageVars.sort[attr] = 1;
					}
					this.pageVars.sortDirection = this.pageVars.sort[attr]
				} else {
					this.pageVars.sortDirection = descending;
				}
				this.fetchSurveySchedules();
			}

			pageChanged(event) {
				this.currentPage = event.page;
				this.fetchSurveySchedules();
			}

			exportSurveySchedule() {
				THIS.service.loadSurveyScheduleList(this.currentPage - 1, this.totalItems, this.pageVars.sortBy, this.pageVars.sortDirection).subscribe(res => {
					this.allSurveySchedules = res.data.result;

					// this.allSurveySchedules = [
					//     {
					//         countryId: { name: "countryId1" },
					//         regionId: { name: "regionId1" },
					//         lastSurveyScheduleYear: "2001",
					//         currentOrNextSurveyScheduleYear: "2002"
					//     },
					//     {
					//         countryId: { name: "countryId2" },
					//         regionId: { name: "regionId2" },
					//         lastSurveyScheduleYear: "2003",
					//         currentOrNextSurveyScheduleYear: "2004"
					//     },
					//     {
					//         countryId: { name: "countryId3" },
					//         regionId: { name: "regionId3" },
					//         lastSurveyScheduleYear: "2005",
					//         currentOrNextSurveyScheduleYear: "2006"
					//     },
					// ]

					let objMap = this.allSurveySchedules.map(ele => {
						let obj = {
							dutyStation: ele.dutystation_info.name,
							country: ele.country_info.name,
							surveyDutyStationCategory: ele.surveyDutyStationCategoryId_info.name,
							lastSurvey: ele.lastSurveyScheduleYear,
							nextSurvey: ele.currentOrNextSurveyScheduleYear,
							nextSurveyStatus: ele.currentOrNextSurveyScheduleStatusId_info.name + ' ' + ele.currentOrNextSurveyScheduleStatusYear,
							methodofAnnualInterimAdjustment: ele.methodofAnnualInterimAdjustmentId_info.name,
							lastCompletedInterimAdjustment: ele.lastCompletedInterimAdjustment
						}
						return [obj.dutyStation, obj.country, obj.surveyDutyStationCategory, obj.lastSurvey, obj.nextSurvey, obj.nextSurveyStatus, obj.methodofAnnualInterimAdjustment, obj.lastCompletedInterimAdjustment]
					})
					// pdfMake.tableLayouts = {
					//     exampleLayout: {
					//         hLineWidth: function (i, node) {
					//             if (i === 0 || i === node.table.body.length) {
					//                 return 0;
					//             }
					//             return (i === node.table.headerRows) ? 2 : 1;
					//         },
					//         vLineWidth: function (i) {
					//             return 0;
					//         },
					//         hLineColor: function (i) {
					//             return i === 1 ? 'black' : '#aaa';
					//         },
					//         paddingLeft: function (i) {
					//             return i === 0 ? 0 : 8;
					//         },
					//         paddingRight: function (i, node) {
					//             return (i === node.table.widths.length - 1) ? 0 : 8;
					//         }
					//     }
					// };
					var docDefinition = {
						header: {
							columns: [
								{ text: 'Survey Schedule', bold: true, alignment: 'center', margin: [0, 5], fontSize: 15 }
							]
						},
						content: [
							{
								layout: 'lightHorizontalLines', // optional
								table: {
									// headerRows: 1,
									// widths: ['*', 'auto', 100, '*'],

									body: [
										[{ text: 'DutyStation', bold: true }, { text: 'Country', bold: true }, { text: 'Category', bold: true }, { text: 'Year of Last Completed Survey', bold: true }, { text: 'Year of Current/Next survey', bold: true }, { text: 'Status of Current/Next Survey', bold: true }, { text: 'Method of Annual Interim Adjustment', bold: true }, { text: 'Last Completed Interim Adjustment', bold: true }],
										...objMap
										// ['countryId1', 'regionId1', 'lastSurveyScheduleYear', 'currentOrNextSurveyScheduleYear1'],
										// ['Value 1', 'Value 2', 'Value 3', 'Value 4'],
										// [{ text: 'Bold value', bold: true }, 'Val 2', 'Val 3', 'Val 4']
									]
								}
							}
						],
						defaultStyle: {
							fontSize: 10
						}
					};
					pdfMake.createPdf(docDefinition).download("survey_schedule");
					//     this.exportPDFTable = `<table>
					//     <thead>
					//     <tr>
					//         <th>name</th>
					//         <th>height</th>
					//         <th>place</th>
					//     </tr>
					//     </thead>
					//     <tbody>
					//     <tr>
					//         <td>Monte Falco</td>
					//         <td>1658</td>
					//         <td>Parco Foreste Casentinesi</td>
					//     </tr>
					//     <tr>
					//         <td>Monte Falterona</td>
					//         <td>1654</td>
					//         <td>Parco Foreste Casentinesi</td>
					//     </tr>
					//     </tbody>
					// </table>`;
				});
			};

		};
		const decoratedCmp = Component(metadata)(cmpClass);

		const decoratedNgModule = NgModule({
			imports: [CommonModule, PaginationModule.forRoot(), NgbModule], declarations:
				[decoratedCmp, SafeHtmlPipe]
		})(cmpClass);

		const module: ModuleWithComponentFactories<any> = compiler.compileModuleAndAllComponentsSync(decoratedNgModule);
		return module.componentFactories.find(f => f.componentType === decoratedCmp);

	}

	fetchSurveySchedule() {
		this.service.loadSurveyScheduleList(this.currentPage - 1, this.pageVars.itemPerPage, this.pageVars.sortBy, this.pageVars.sortDirection).subscribe((response: any) => {
			console.log('response.data', this.currentPage - 1, this.pageVars.itemPerPage, this.pageVars.sortBy, this.pageVars.sortDirection);
			if (response.data) {
				this.surveyscheduleList = response.data.result;
				this.totalItems = response.data.total;
				//this.resourcesList = response.data.resourcesId;
				//console.log('response.data',response.data.result);
			}
		});

	}

	sortSurveySchedule(attr, descending) {
		this.pageVars.sortBy = attr;
		this.pageVars.sortDirection = descending;
		this.fetchSurveySchedule();
	}

	pageChanged(event) {
		// itemsPerPage: 2
		this.currentPage = event.page;
		// console.log(event);
		this.fetchSurveySchedule();
	}

}